import { render, staticRenderFns } from "./DigitalCopyrightRegistration.vue?vue&type=template&id=3de9596e&scoped=true"
import script from "./DigitalCopyrightRegistration.vue?vue&type=script&lang=js"
export * from "./DigitalCopyrightRegistration.vue?vue&type=script&lang=js"
import style0 from "./DigitalCopyrightRegistration.vue?vue&type=style&index=0&id=3de9596e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de9596e",
  null
  
)

export default component.exports